import {put, takeEvery, all} from 'redux-saga/effects';
import {showNotification} from 'admin-on-rest';

function* fuseNoServerAvailable() {
    yield put(showNotification('No Server Available.', 'warning'));
}

function* fuseNoAdminAccess() {
    yield put(showNotification('Cannot access CloudSent POS Admin.', 'warning'));
}

export default function* fuseSaga() {
    yield all([
        takeEvery('FUSE_NO_ADMIN_ACCESS', fuseNoAdminAccess),
        takeEvery('FUSE_NO_SERVER', fuseNoServerAvailable)
    ]);
}


// WEBPACK FOOTER //
// ./src/Fuse/admin/fuseSaga.js